// Dedicated SEO service pages content.
const A = "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts";

export const servicePages = [
  {
    slug: "drone-land-survey",
    nav: "Drone Land Survey",
    title: "Drone Land Survey Services India | Topographic & GIS Mapping — Snesar",
    description:
      "Professional drone land survey services in India. Drone topographic survey, cadastral & boundary survey, contour mapping, DEM/DSM, area & volume calculation with GIS-ready outputs.",
    keywords:
      "Drone Land Survey, Land Survey Using Drone, Drone Topographic Survey, Drone Cadastral Survey, Drone Boundary Survey, Drone Contour Survey, Drone Terrain Mapping, Drone Area Measurement, Drone Volume Calculation, Drone Earthwork Survey, Drone Stockpile Survey, Drone Mine Survey, Drone GIS Survey India",
    hero: `${A}/grhqax9j_Screenshot%202026-07-08%20150135.webp`,
    heroFit: "object-cover",
    h1: "Drone Land Survey Services",
    lead:
      "High-accuracy drone land survey using photogrammetry to deliver survey-grade topographic maps, contours and GIS-compatible data — faster and safer than traditional ground survey.",
    sections: [
      {
        heading: "What our drone land survey delivers",
        points: [
          "Drone topographic survey & contour mapping",
          "Cadastral and boundary surveys",
          "Digital Elevation Model (DEM) & Digital Surface Model (DSM)",
          "Orthomosaic maps and 2D/3D deliverables",
          "Accurate area & volume calculations",
          "GIS-compatible outputs (SHP, DWG, GeoTIFF, LAS)",
        ],
      },
      {
        heading: "Applications",
        points: [
          "Earthwork and stockpile volume surveys",
          "Mine and quarry surveys",
          "Township, industrial and infrastructure planning",
          "Urban planning and land-parcel documentation",
        ],
      },
    ],
    highlight:
      "Flagship project: CIDCO – NAINA land survey of 3,000 acres in Panvel — part of 100+ land survey projects delivered.",
  },
  {
    slug: "lidar-survey",
    nav: "LiDAR Survey",
    title: "Drone LiDAR Survey India | Point Cloud, DTM, DSM, DEM — Snesar",
    description:
      "Drone LiDAR survey services in India. High-density point cloud generation, vegetation-penetration LiDAR, DTM/DSM/DEM, corridor, railway, highway, forest and powerline LiDAR mapping.",
    keywords:
      "LiDAR Drone Survey, Drone LiDAR Survey India, LiDAR Mapping Services, LiDAR Point Cloud, Digital Terrain Model DTM, Digital Surface Model DSM, Digital Elevation Model DEM, Vegetation Penetration LiDAR, Corridor LiDAR Survey, Railway LiDAR Survey, Highway LiDAR Survey, Powerline LiDAR Survey, Forest LiDAR Mapping",
    hero: `${A}/bv9f192n_639331e91a01b480a4894faf_ugcs-drone-based-lidar-survey-topo-2.jpg`,
    heroFit: "object-cover",
    h1: "Drone LiDAR Survey India",
    lead:
      "LiDAR drone survey for dense, accurate point clouds — capturing ground beneath vegetation and generating engineering-grade terrain models for corridor and utility projects.",
    sections: [
      {
        heading: "LiDAR capabilities",
        points: [
          "High-density point cloud generation",
          "Digital Terrain Model (DTM), DSM & DEM",
          "Vegetation-penetration terrain mapping",
          "Digital twin creation & corridor mapping",
          "Engineering-grade deliverables (LAS/LAZ)",
        ],
      },
      {
        heading: "Corridor & utility LiDAR",
        points: [
          "Railway and highway LiDAR survey",
          "Powerline and utility LiDAR survey",
          "Forest and environmental LiDAR mapping",
          "Infrastructure and utility corridor surveys",
        ],
      },
    ],
  },
  {
    slug: "construction-progress-monitoring",
    nav: "Construction Progress Monitoring",
    title: "Construction Progress Monitoring by Drone | Site Reports — Snesar",
    description:
      "Drone construction progress monitoring in India. Weekly & monthly progress drone surveys, construction drone photography & videography, time-lapse documentation and site progress reports.",
    keywords:
      "Construction Progress Monitoring, Drone Construction Monitoring, Construction Drone Photography, Construction Drone Videography, Monthly Progress Drone Survey, Weekly Drone Progress Report, Infrastructure Monitoring, Time Lapse Construction, Construction Documentation, Site Progress Reports, Construction Aerial Photography",
    hero: `${A}/ks8q0yor_DJI_0099%20-%20Copy.webp`,
    heroFit: "object-cover",
    h1: "Construction Progress Monitoring",
    lead:
      "Consistent, fixed-GPS aerial documentation that lets owners, consultants and contractors track construction progress and communicate milestones with confidence.",
    sections: [
      {
        heading: "Monitoring services",
        points: [
          "Weekly & monthly progress drone surveys",
          "Construction drone photography & videography",
          "Fixed GPS position monitoring for comparisons",
          "Time-lapse construction documentation",
          "Graphic-edited progress videos",
          "Client reporting dashboards & site progress reports",
        ],
      },
    ],
    highlight:
      "Flagship project: 4 years of continuous construction progress monitoring at Navi Mumbai International Airport (2022–2026).",
  },
  {
    slug: "drone-inspection",
    nav: "Drone Inspection",
    title: "Drone Inspection Services India | Industrial & Thermal — Snesar",
    description:
      "Industrial drone inspection services in India. Building, bridge, dam, tower, chimney, roof, solar plant, wind turbine, thermal, oil & gas, pipeline, tank, factory and warehouse inspection.",
    keywords:
      "Drone Inspection Services, Industrial Drone Inspection, Infrastructure Inspection, Asset Inspection, Building Inspection, Bridge Inspection, Dam Inspection, Tower Inspection, Chimney Inspection, Roof Inspection, Solar Plant Inspection, Wind Turbine Inspection, Thermal Drone Inspection, Oil & Gas Inspection, Pipeline Inspection, Factory Inspection, Warehouse Inspection",
    hero: `${A}/gw30j23r_b0f383fe-d9cb-4b61-98cc-08c612d05d19.webp`,
    heroFit: "object-cover",
    h1: "Drone Inspection Services",
    lead:
      "Safe, high-resolution and thermal drone inspection of hard-to-reach assets — detecting defects and hotspots for preventive maintenance without downtime or scaffolding.",
    sections: [
      {
        heading: "Inspection coverage",
        points: [
          "Building, bridge, dam and tower inspection",
          "Chimney and roof inspection",
          "Solar plant & wind turbine inspection",
          "Thermal drone inspection & hotspot detection",
          "Oil & gas, pipeline and tank inspection",
          "Factory and warehouse inspection",
        ],
      },
    ],
  },
  {
    slug: "powerline-inspection",
    nav: "Powerline Inspection",
    title: "Powerline & Transmission Line Inspection by Drone — Snesar",
    description:
      "Drone powerline inspection in India. Transmission line and power tower inspection, thermal power inspection, substation inspection and preventive maintenance reporting.",
    keywords:
      "Powerline Inspection, Transmission Line Inspection, Power Tower Inspection, Electrical Inspection Drone, Utility Inspection Drone, Thermal Power Inspection, Substation Inspection, Power Infrastructure Survey",
    hero: `${A}/gw30j23r_b0f383fe-d9cb-4b61-98cc-08c612d05d19.webp`,
    heroFit: "object-cover",
    h1: "Powerline Inspection",
    lead:
      "Thermal and visual drone inspection of transmission lines, towers and substations — pinpointing hotspots and defects across difficult terrain for safer, preventive maintenance.",
    sections: [
      {
        heading: "Powerline inspection scope",
        points: [
          "Transmission line inspection",
          "Power tower inspection",
          "Thermal camera hotspot detection",
          "Substation inspection",
          "Defect detection & preventive maintenance reporting",
        ],
      },
    ],
    highlight:
      "Flagship project: thermal powerline inspection for Central Railway across the Lonavala & Igatpuri ghat sections.",
  },
  {
    slug: "railway-survey",
    nav: "Railway Survey",
    title: "Railway Drone Survey & Construction Monitoring India — Snesar",
    description:
      "Railway drone survey and railway construction monitoring in India. Metro rail drone survey, bridge construction monitoring and geo-tagged railway corridor documentation.",
    keywords:
      "Railway Drone Survey, Railway Construction Monitoring, Metro Rail Drone Survey, Bridge Construction Monitoring, Railway LiDAR Survey, Geo Tagged Survey, Railway Corridor Survey",
    hero: `${A}/21b19545_WhatsApp%20Image%202025-10-29%20at%2010.06.48%20AM.jpeg`,
    heroFit: "object-cover",
    h1: "Railway Drone Survey",
    lead:
      "GPS-referenced drone survey and progress monitoring for railway and metro corridors — from alignment mapping to bridge construction monitoring.",
    sections: [
      {
        heading: "Railway survey services",
        points: [
          "Railway drone survey & corridor mapping",
          "Railway construction monitoring",
          "Metro rail drone survey",
          "Bridge construction monitoring",
          "Geo-tagged, GPS-referenced documentation",
        ],
      },
    ],
  },
  {
    slug: "airport-construction-monitoring",
    nav: "Airport Construction Monitoring",
    title: "Airport Drone Survey & Construction Monitoring India — Snesar",
    description:
      "Airport drone survey and airport construction monitoring in India. Runway survey, aviation infrastructure survey and airport progress photography & videography.",
    keywords:
      "Airport Drone Survey, Airport Construction Monitoring, Runway Survey, Aviation Infrastructure Survey, Airport Progress Photography, Airport Construction Progress",
    hero: `${A}/wc451ao8_DJI_1025%20%281%29.webp`,
    heroFit: "object-cover",
    h1: "Airport Construction Monitoring",
    lead:
      "Long-term aerial documentation for airport and aviation infrastructure — runway surveys, terminal progress photography and time-lapse videography at scale.",
    sections: [
      {
        heading: "Airport monitoring services",
        points: [
          "Airport drone survey & runway survey",
          "Aviation infrastructure survey",
          "Terminal & apron progress photography",
          "Time-lapse construction documentation",
          "Scheduled progress reporting",
        ],
      },
    ],
    highlight:
      "Flagship project: 4 years of continuous monitoring at Navi Mumbai International Airport (2022–2026).",
  },
  {
    slug: "drone-photography",
    nav: "Drone Photography",
    title: "Drone Photography Services India | Aerial Photographer — Snesar",
    description:
      "Professional drone photography services in India. Commercial, industrial, construction, infrastructure, project and real estate aerial photography in high resolution.",
    keywords:
      "Drone Photography India, Drone Photography Services, Professional Drone Photographer, Aerial Photography, Commercial Drone Photography, Industrial Drone Photography, Construction Photography, Real Estate Photography, Infrastructure Photography, Project Photography",
    hero: `${A}/kujwlks2_Screenshot%202026-07-08%20150521.jpg`,
    heroFit: "object-cover",
    h1: "Drone Photography Services",
    lead:
      "High-resolution aerial photography for commercial, industrial, construction and real estate projects — striking imagery that showcases scale and detail.",
    sections: [
      {
        heading: "Photography services",
        points: [
          "Commercial & industrial aerial photography",
          "Construction and infrastructure photography",
          "Real estate and project photography",
          "High-resolution still imagery",
        ],
      },
    ],
  },
  {
    slug: "drone-videography",
    nav: "Drone Videography",
    title: "Drone Videography India | 4K Aerial & Corporate Films — Snesar",
    description:
      "Drone videography services in India. 4K aerial videography, corporate and industrial drone films, FPV drone video, construction and promotional videos.",
    keywords:
      "Drone Videography India, Aerial Videography, Commercial Drone Video, Corporate Drone Film, Industrial Drone Video, Construction Drone Video, Infrastructure Drone Video, Promotional Drone Video, 4K Drone Videography, FPV Drone Video",
    hero: `${A}/vrhmuh6q_Screenshot%202026-07-08%20143107.webp`,
    heroFit: "object-cover",
    h1: "Drone Videography",
    lead:
      "Cinematic 4K aerial and FPV videography — corporate films, industrial walkthroughs, construction updates and promotional videos that captivate.",
    sections: [
      {
        heading: "Videography services",
        points: [
          "4K aerial & commercial drone video",
          "Corporate and industrial drone films",
          "FPV drone video & indoor fly-throughs",
          "Construction and promotional videos",
        ],
      },
    ],
  },
  {
    slug: "real-estate-drone-services",
    nav: "Real Estate Drone Services",
    title: "Real Estate Drone Photography & Video India — Snesar",
    description:
      "Real estate drone photography and videography in India. Property drone shoots, township and luxury project videos, 360° virtual tours and construction marketing videos.",
    keywords:
      "Real Estate Drone Photography, Real Estate Drone Videography, Property Drone Shoot, Commercial Property Photography, Residential Project Drone Video, Township Drone Video, Luxury Property Drone Shoot, Construction Marketing Video, 360 Virtual Tour, Floor Wise 360 View",
    hero: `${A}/3cdk9ati_IMG_20260325_104722265.webp`,
    heroFit: "object-cover",
    h1: "Real Estate Drone Services",
    lead:
      "Property showcase and lifestyle films that sell faster — aerial marketing, floor-wise 360° views and location-advantage videos for residential and commercial projects.",
    sections: [
      {
        heading: "Real estate services",
        points: [
          "Property showcase videos & photography",
          "Location advantage & lifestyle films",
          "Township & luxury project drone videos",
          "Floor-wise 360° views & virtual tours",
          "Social media promotional content",
        ],
      },
    ],
  },
];

export const getServiceBySlug = (slug) =>
  servicePages.find((p) => p.slug === slug);
